import type { ChatbotState } from '../index';

export const setActiveHistoryId = (state: ChatbotState, { payload }: { payload: string | null }) => {
  state.activeHistoryId = payload;
};
